/**
 * Constants for AgentHeadshotUploader component
 */

// Image aspect ratio configuration
export const IMAGE_ASPECT_RATIO = {
  WIDTH: 1,
  HEIGHT: 1.2,
  RATIO: 1 / 1.2, // 0.8333...
}

// Image quality settings
export const IMAGE_QUALITY = {
  JPEG: 0.95,
  MIN_WIDTH: 600,
  MAX_WIDTH: 1200,
  OPTIMAL_WIDTH: 800,
  HIGH_RES_THRESHOLD: 1000,
}

// Crop settings
export const CROP_SETTINGS = {
  INITIAL_WIDTH_PERCENT: 98, // 98% crop selector on 100% visible image
  MIN_WIDTH: 150,
  MIN_HEIGHT: 180,
  ASPECT_RATIO: IMAGE_ASPECT_RATIO.RATIO,
  UNIT: 'px',
  PERCENTAGE_UNIT: '%',
}

// Canvas settings
export const CANVAS_SETTINGS = {
  BACKGROUND_COLOR: '#f8f9fa',
  BORDER_COLOR: '#e9ecef',
  BORDER_RATIO: 0.00333, // 1/300 of canvas width
  PADDING_RATIO: 0.98,
  IMAGE_SMOOTHING_QUALITY: 'high',
}

// Processing delays
export const PROCESSING_DELAYS = {
  IMAGE_CONVERSION: 500, // ms
}

// File upload settings
export const UPLOAD_SETTINGS = {
  FILE_NAME: 'headshot.jpeg',
  MIME_TYPE: 'image/jpeg',
  PNG_MIME_TYPE: 'image/png',
  FORM_FIELD_NAME: 'u_picture',
  FORM_FILENAME_FIELD: 'u_picture_filename',
}

// UI Messages
export const UI_MESSAGES = {
  PROCESSING: '🔄 Converting image to profile picture ratio...',
  PROCESSED: 'Image converted to profile picture ratio (1:1.2)',
  LOADING: 'Image loaded (processing...)',
  ORIGINAL: 'Original image (ready for cropping)',
  UPLOAD_SUCCESS: 'Headshot uploaded successfully!',
  UPLOAD_ERROR: 'Failed to upload headshot. Please try again.',
  PROCESSING_ERROR: 'Failed to process image. Please try again.',
}

// Environment config key for enabling/disabling crop feature
export const ENV_CONFIG = {
  ENABLE_CROP_KEY: 'features.enableHeadshotCrop',
  DEFAULT_ENABLE_CROP: true,
}
